<span [ngClass]="classNames">
	<span [ngClass]="'loading-spinner__label' | prefix: prefix">Loading...</span>
</span>
